import { Validators } from '@angular/forms';
import { TableCols } from '../interfaces/static-data';

export const DESKS: TableCols[] = [
  {
    key: 'issuerId',
    displayValue: 'Issuer Entity',
    type: 'select',
    validators: [Validators.required],
  },
  {
    key: 'deskType',
    displayValue: 'Desk Type',
    validators: [Validators.required],
    type: 'select',
    items: [
      {
        id: 'OPERATIONS',
        displayValue: 'Operations',
      },
      {
        id: 'SALES',
        displayValue: 'Sales',
      },
      {
        id: 'STRUCTURING',
        displayValue: 'Structuring',
      },
      {
        id: 'TRADING',
        displayValue: 'Trading',
      },
    ],
  },
  {
    key: 'name',
    displayValue: 'Desk Name',
    validators: [Validators.required],
  },
];
